import React, { useEffect, useState } from "react";
import { searchshift, getboardinglist } from "../../services/Driverservice";
import Select from "react-select";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FaUser } from "react-icons/fa";
import { FaMapMarkedAlt } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { employeein } from "../../services/Driverservice";
import { parse, format } from "date-fns";
import { FaMapMarkerAlt } from "react-icons/fa";
const Boardingpass = () => {
  const [loading, setLoading] = useState(false);
  const [inloading, setInloading] = useState(false);
  const [shiftdata, setShiftdata] = useState([]);
  const [selectedshiftdata, setSelectedshidtdata] = useState(null);
  const [data, setData] = useState([]);
  const [selecetempid, setSelectempid] = useState("");
  const [exitModalOpen, setExitModalOpen] = useState(false);
  const toggleExitModal = () => setExitModalOpen(!exitModalOpen);
  useEffect(() => {
    searchshift()
      .then((res) => {
        setShiftdata(res.data);
        setSelectedshidtdata(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    const handleboardinglist = (id) => {
      setData([]);
      setLoading(true);
      getboardinglist({ shift: id })
        .then((res) => {
          console.log(res.data);
          setData(res.data.results);
        })
        .catch((err) => {
          toast.error(err.response.data.message);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    if (selectedshiftdata && selectedshiftdata.value) {
      handleboardinglist(selectedshiftdata?.value);
    }
  }, [selectedshiftdata]);
  const handlein = () => {
    setInloading(true);
    employeein({ employee_id: selecetempid })
      .then((res) => {
        setSelectempid("");
        toggleExitModal();
        toast.success("Employee IN Successfully");
      })
      .catch((err) => {
        toast.error(err.response.data.detail);
      })
      .finally(() => {
        setInloading(false);
      });
  };
  return (
    <div className="container-fluid py-4">
      <div className="row mb-3">
        <div className="col">
          <span
            className="text-primary"
            style={{ fontSize: "1.2rem", fontWeight: "500" }}
          >
            Boarding Pass
          </span>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Boarding Pass
            </li>
          </ol>
        </div>
      </div>
      <div className="row d-flex justify-content-between align-items-center mb-4">
        <h4 className="col-12 col-sm-6 col-lg-6 text-primary fw-bold mb-0">
          🚌 Employee Pickup Stops
        </h4>
        <div className="col-12 col-sm-6 col-lg-4">
          <Select
            options={shiftdata}
            value={selectedshiftdata}
            onChange={(select) => {
              setSelectedshidtdata(select);
            }}
            className="react-select"
            classNamePrefix="select"
            placeholder="Select Shift"
          />
        </div>
      </div>
      {loading ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "60vh" }}
        >
          <Spinner animation="border" variant="primary" />
          <span className="mt-2">Loading boarding list...</span>
        </div>
      ) : data.length === 0 ? (
        <div className="text-center py-5">
          <span>No Data Found</span>
        </div>
      ) : (
        <>
          <div className="mb-4">
            <h5 className="fw-bold text-secondary">
              🛑 Total Stops: {data.length}
            </h5>
          </div>
          <div className="row">
            {data?.map((stop, index) => (
              <div className="col-12 d-flex mb-4" key={index}>
                <div className="d-flex flex-column align-items-center me-3">
                  <div className="d-flex flex-column align-items-center mb-1">
                    <div className="badge bg-primary d-flex align-items-center gap-1">
                      <FaMapMarkerAlt size={15} /> {`Stop ${index + 1}`}
                    </div>
                    <small className="text-info">
                      {format(
                        parse(stop.arrival_time, "HH:mm:ss", new Date()),
                        "hh:mm a"
                      )}
                    </small>
                  </div>
                  {index < data.length - 1 && (
                    <div
                      style={{ height: "100%", borderLeft: "2px dashed #ccc" }}
                    ></div>
                  )}
                </div>
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                    <h5 className="fw-semibold mb-0 text-primary">
                      {stop.stop_name}
                    </h5>
                    <span className="badge bg-info text-white">
                      {stop.employees.length} Employees
                    </span>
                  </div>
                  <div className="d-flex flex-wrap gap-3">
                    {stop.employees.map((emp) => (
                      <div
                        style={{ minHeight: "50px" }}
                        key={emp.id}
                        onClick={() => {
                          setSelectempid(emp?.id);
                          toggleExitModal();
                        }}
                      >
                        <div className="badge bg-white shadow-sm border-0 p-2 d-flex align-items-center">
                          <FaUser className="me-1 text-primary" size={18} />
                          <span
                            className="fw-bold mb-0 text-dark"
                            style={{ fontSize: "1rem" }}
                          >
                            {emp.name}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <Modal
            className="modal modal-top modal-sm fade"
            id="exampleModal3"
            show={exitModalOpen}
            onHide={toggleExitModal}
          >
            <div className="modal-content">
              <div className="modal-header justify-content-center">
                <h3 className="modal-title">In/Out</h3>
              </div>
              <div className="modal-body">
                <p className="text-center">Are you Confirm to In</p>
                <div className="d-flex align-items-center justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-outline-primary btn-sm me-1"
                    onClick={handlein}
                  >
                    {inloading ? (
                      <>
                        <Spinner animation="border" size="sm" />
                        <span className="ms-1">Loading...</span>
                      </>
                    ) : (
                      "Yes"
                    )}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setSelectempid("");
                      toggleExitModal();
                    }}
                    className="btn btn-primary  btn-sm  mx-2"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Boardingpass;
